import React, { useState } from 'react';
import { Badge, Button, Drawer, Stack } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

/**
 * Фильтры над таблицей на телефоне.
 *
 * На десктопе выпадающие списки стоят в строку с фиксированной шириной; на узком экране
 * они либо вылезают за край, либо занимают пол-экрана над списком. Поэтому здесь
 * одна кнопка со сводкой выбранного, а сами поля — в выезжающей снизу панели,
 * во всю ширину. Значения применяются сразу, как и на десктопе: «Готово» только
 * закрывает панель.
 *
 * activeCount — сколько фильтров отличается от «Все», для счётчика на кнопке.
 */
const MobileFilters = ({ summary, activeCount = 0, onReset, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
        <Badge badgeContent={activeCount} color="warning">
          <Button
            variant="outlined" startIcon={<FilterListIcon />}
            onClick={() => setOpen(true)}
          >
            Фильтры
          </Button>
        </Badge>
        {summary && (
          <span className="journal-muted" style={{ overflowWrap: 'anywhere' }}>{summary}</span>
        )}
      </Stack>

      <Drawer
        anchor="bottom" open={open} onClose={() => setOpen(false)}
        PaperProps={{ sx: { borderTopLeftRadius: 12, borderTopRightRadius: 12, maxHeight: '85vh' } }}
      >
        <Stack spacing={2} sx={{ p: 2, pb: 3 }}>
          <p className="journal-subtitle" style={{ margin: 0 }}>Фильтры</p>

          {children}

          <Stack direction="row" spacing={1}>
            {onReset && (
              <Button onClick={onReset} disabled={activeCount === 0} fullWidth>
                Сбросить
              </Button>
            )}
            <Button variant="contained" onClick={() => setOpen(false)} fullWidth>
              Готово
            </Button>
          </Stack>
        </Stack>
      </Drawer>
    </>
  );
};

export default MobileFilters;
